module.exports = __webpack_public_path__ + "272a3b9e679145f5a16478d10749cfdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weakid_logo_small.png
// module id = 1208
// module chunks = 0